import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { useAuth } from './AuthContext'

// Use plain axios — NOT api.js (baseURL '/api') — so the request goes to /auth/exchange,
// not /api/auth/exchange which is behind the authenticate middleware.
const AUTH_BASE = import.meta.env.VITE_API_URL || ''

export default function AuthCallback() {
  const navigate    = useNavigate()
  const { setUser } = useAuth()
  const [status, setStatus] = useState('Signing you in…')
  const didExchange = useRef(false)   // guard against React StrictMode double-invoke

  useEffect(() => {
    if (didExchange.current) return   // second StrictMode invocation — skip
    didExchange.current = true

    const params = new URLSearchParams(window.location.search)
    const code   = params.get('code')
    const error  = params.get('error')

    if (error || !code) {
      navigate('/login?error=' + (error || 'no_code'), { replace: true })
      return
    }

    // Exchange the one-time code for the JWT — code is invalidated immediately
    // and never persists in browser history, logs, or referrer headers
    axios.post(`${AUTH_BASE}/auth/exchange`, { code }, { withCredentials: true })
      .then(({ data }) => {
        const token = data.accessToken
        if (!token) throw new Error('no token')

        localStorage.setItem('e4f_session', '1')
        window.__accessToken = token

        const payload = JSON.parse(atob(token.split('.')[1]))
        setUser({
          id:         payload.userId,
          email:      payload.email,
          name:       payload.name,
          role:       payload.role,
          tenantId:   payload.tenantId,
          tenantSlug: payload.tenantSlug,
          plan:       payload.plan,
        })
        navigate('/', { replace: true })
      })
      .catch(() => {
        setStatus('Sign-in failed. Redirecting…')
        setTimeout(() => navigate('/login?error=exchange_failed', { replace: true }), 1500)
      })
  }, [])

  return (
    <div className="fixed inset-0 bg-slate-900 flex items-center justify-center">
      <div className="text-center">
        <div className="text-3xl font-bold text-blue-400 mb-2">Edge4Field</div>
        <div className="text-slate-400 text-sm">{status}</div>
      </div>
    </div>
  )
}
